var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialogModel',{attrs:{"title":"选择服务范围","visible":_vm.dialogServiceScope},on:{"update:visible":function($event){_vm.dialogServiceScope=$event},"handleClose":_vm.handleCloseServiceScope,"handleOk":_vm.ServiceScope}},[_c('div',{staticClass:"main-body"},[_c('div',{staticClass:"MajorItems"}),_c('div',{staticClass:"MinorItems"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }